module.exports = __webpack_public_path__ + "img/大哭.ac2375c5.gif";